module.exports = __webpack_public_path__ + "img/56.550af165.png";